function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from '../../_snowpack/pkg/react.js';
import mitt from '../../_snowpack/pkg/mitt.js';
const emitter = mitt();
export const showFeedback = ({
  type = 'info',
  ...rest
}) => emitter.emit('show', {
  type,
  ...rest
});
export const hideFeedback = props => emitter.emit('hide', props);
export class FeedbackWrapper extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      show: false,
      message: '',
      type: 'error'
    });

    _defineProperty(this, "show", ({
      message,
      type,
      onDismiss
    }) => {
      this.setState({
        show: true,
        message,
        type,
        onDismiss
      });
    });

    _defineProperty(this, "hide", () => this.toggleDialogue());

    _defineProperty(this, "toggleDialogue", () => {
      this.setState({
        show: false,
        type: '',
        message: '',
        onDismiss: null
      });

      if (this.state.onDismiss) {
        this.state.onDismiss();
      }
    });
  }

  componentDidMount() {
    emitter.on('show', this.show);
    emitter.on('hide', this.hide);
  }

  componentWillUnmount() {
    emitter.off('show', this.show);
    emitter.off('hide', this.hide);
  }

  render() {
    const {
      show
    } = this.state;
    if (!show) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "feedback"
    }, /*#__PURE__*/React.createElement("div", {
      className: "feedback-dialogue"
    }, /*#__PURE__*/React.createElement("div", {
      className: "feedback-dialogue-content"
    }, this.feedbackType())));
  }

  feedbackType() {
    const {
      type
    } = this.state;

    switch (type.toLowerCase()) {
      case 'loader':
        return /*#__PURE__*/React.createElement(LoadingDialogue, this.state);

      case 'error':
        return /*#__PURE__*/React.createElement(ErrorDialogue, this.state);

      case 'info':
        return /*#__PURE__*/React.createElement(InfoDialogue, this.state);

      case 'success':
        return /*#__PURE__*/React.createElement(SuccessDialogue, this.state);

      default:
        return null;
    }
  }

}

function SuccessDialogue({
  message
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "feedback-error"
  }, /*#__PURE__*/React.createElement("h4", null, "Its all good"), /*#__PURE__*/React.createElement("p", null, message), /*#__PURE__*/React.createElement("span", {
    className: "feedback-error__action",
    onClick: hideFeedback
  }, "Thanks"));
}

function InfoDialogue({
  message
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "feedback-error"
  }, /*#__PURE__*/React.createElement("h4", null, "Did you forget something ?"), /*#__PURE__*/React.createElement("p", null, message), /*#__PURE__*/React.createElement("span", {
    className: "feedback-error__action",
    onClick: hideFeedback
  }, "OK champ"));
}

function ErrorDialogue({
  message
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "feedback-error"
  }, /*#__PURE__*/React.createElement("h4", null, "Oh my! That was unexpected ..."), /*#__PURE__*/React.createElement("p", null, message), /*#__PURE__*/React.createElement("span", {
    className: "feedback-error__action",
    onClick: hideFeedback
  }, "I accept your failure"));
}

function LoadingDialogue({
  message
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "feedback-loading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feedback-loading__loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feedback-loading__loader-inner"
  })), /*#__PURE__*/React.createElement("h4", null, message));
}